export const ACTIVARTOTP_LOADING = "ACTIVARTOTP_LOADING";
export const ACTIVARTOTP_SUCCESS = "ACTIVARTOTP_SUCCESS";
export const ACTIVARTOTP_ERROR = "ACTIVARTOTP_ERROR";
export const ACTIVARTOTP_RESET = "ACTIVARTOTP_RESET";

export const CHECKACTIVO_LOADING = "CHECKACTIVO_LOADING";
export const CHECKACTIVO_SUCCESS = "CHECKACTIVO_SUCCESS";
export const CHECKACTIVO_ERROR = "CHECKACTIVO_ERROR";
export const CHECKACTIVO_RESET = "CHECKACTIVO_RESET";

export const RESET_CONTEXT = "RESET_CONTEXT";

export const TEXTOS_LOADING = "TEXTOS_LOADING";
export const TEXTOS_SUCCESS = "TEXTOS_SUCCESS";
export const TEXTOS_ERROR = "TEXTOS_ERROR";
export const TEXTOS_RESET = "TEXTOS_RESET";